import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { AccessResult } from "utils/access";
import PermissionGateDropdownItem from "components/PermissionGate/DropdownMenuItem";

import { showDeleteConfirmation } from "./DeleteConfirmation";

type WebhookDropdownProps = {
  onEditClick: () => void;
  onDetailsClick: () => void;
  canManageModule: AccessResult;
  endpoint: string;
  id: string;
  refetchQueriesOnDelete?: string[];
  moduleId: string;
};

const WebhookDropdown = ({
  onEditClick,
  refetchQueriesOnDelete,
  endpoint,
  id,
  moduleId,
  onDetailsClick,
  canManageModule,
}: WebhookDropdownProps) => {
  const handleDeleteClick = () => {
    showDeleteConfirmation({ endpoint, id, refetchQueriesOnDelete, moduleId });
  };

  return (
    <DropdownMenuEllipsis tooltip="Webhook actions">
      <DropdownMenuItem onAction={onDetailsClick}>Details</DropdownMenuItem>
      <PermissionGateDropdownItem access={canManageModule} onAction={onEditClick}>
        Edit
      </PermissionGateDropdownItem>
      <PermissionGateDropdownItem access={canManageModule} onAction={handleDeleteClick} danger>
        Delete
      </PermissionGateDropdownItem>
    </DropdownMenuEllipsis>
  );
};

export default WebhookDropdown;
